import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";

import { getOperators } from "../api";

const operatorsQueryOptions = {
  all: () => ["impersonation-operators"] as const,
  list: (enabled: boolean) =>
    queryOptions({
      queryKey: operatorsQueryOptions.all(),
      queryFn: enabled ? ({ signal }) => getOperators(signal) : skipToken,
    }),
};

function useOperators(enabled: boolean) {
  const query = useQuery(operatorsQueryOptions.list(enabled));

  return {
    operators: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}

export { operatorsQueryOptions, useOperators };
